import React from "react";

export function Footer()
{
    return(
        
<div className="row d-flex justify-content-center">
    <div className="col-lg-10">

        <div className="row d-flex justify-content-between p-4">
            <div className="col-lg-8 mb-5">
                <div className="d-flex flex-column gap-2 mt-5">
                    <span className="color-orange font-xl mb-3"> Universites du Senegal </span>
                    <a href="/" className="link link-outline"> UCAD de Dakar </a>
                    <a href="/" className="link link-outline"> UGB de Saint louis </a>
                    <a href="/" className="link link-outline"> USSEIN </a>
                    <a href="/" className="link link-outline"> UT de Thies </a>
                    <a href="/" className="link link-outline"> UASZ de Ziguinchor </a>
                    <a href="/" className="link link-outline"> UADB de Bambey </a>
                    <a href="/" className="link link-outline"> UAMMD de Diameniadio </a>
                    <a href="/" className="link link-outline"> UVS </a>
                </div>
            </div>
            <div className="col-lg-4">
                <div className="mt-5">
                    <div className="mb-4 p-3 border-orange bg-dark rounded-2">
                        <span className="font-lg color-orange " > La plateforme Samadoc </span>
                    </div>
                    <span className="fs-md color-light"> Samadoc est une plateforme de partage de documents académiques pour toute la communauté éducative. Elle constitue un espace centralisé et sécurisé pour l'échange de documents essentiels à l'apprentissage. </span>
                    <div className="mt-4 color-light"> <a href="https://xelkoomai.sn" className="btn btn-light-outline btn-lg"> Apropos de Xelkom-AI </a> </div>
                </div>
            </div>
        </div>
    </div>   

    <div className="col-lg-12 bg-dark border-top border-dark">
         <FootBar />
    </div>

</div>

    )
}

export function FootBar()
{
    return(
        <div className="row d-flex justify-content-between p-4"> 
            <div className="col-lg-5 col-md-7 d-flex justify-content-center gap-3">
                <span className="color-light"> powered by Xelkoom-AI </span>
                <span className="border"></span>
                <a href="/condition-utilisation" className="link link-outline"> condition d'utilistaion </a>    
            </div>
            <div className="col-lg-4 col-md-1"></div>
            <div className="col-lg-3 col-md-4 d-flex justify-content-center">
                <span className="color-light"> Copyright © 2023  </span>    
            </div>
        </div>  
    )
}